//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming



export interface UserResponse {
    id: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dnvName?: string | undefined;
    userName?: string | undefined;
    veracityId?: string | undefined;
    email?: string | undefined;
    employerId: number;
    termsOfUseAccepted: boolean;
    isEnabled: boolean;
    veracityMessageCount: number;
    organization?: OrganizationSimple | undefined;
    roles?: UserRoleSimple[] | undefined;
}

export interface OrganizationBase {
    id: number;
    name?: string | undefined;
    description?: string | undefined;
    isDefault: boolean;
    subscriptionExpirationDate?: Date | undefined;
    pricePlanId: number;
    pricePlanName?: string | undefined;
    hasAccessToApi: boolean;
    createdAt: Date;
}

export interface OrganizationSimple extends OrganizationBase {
    maxCalculationRequests: number;
    actuallyCalculationRequests: number;
    maxParallelCalculations: number;
    actuallyParallelCalculations: number;
}

export interface UserRoleSimple {
    id: number;
    name?: string | undefined;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export interface ApiKeySimple {
    id: number;
    key: string;
    isActive: boolean;
    expirationDate: Date;
    ownerId: string;
}

export interface GetAllSelectionOptionsResponse {
    isoBaList?: SelectListItem[] | undefined;
    systemConfigurationsList?: SelectListItem[] | undefined;
    runOptionsList?: SelectListItem[] | undefined;
    wholesaleMarketLibraryDatasets?: SelectListItem[] | undefined;
    finansesLibraryDatasets?: SelectListItem[] | undefined;
    taxDepreciationTypes?: SelectListItem[] | undefined;
    pvProductionSoftwareTypes?: SelectListItem[] | undefined;
}

export interface SelectListItem {
    disabled: boolean;
    group?: SelectListGroup | undefined;
    selected: boolean;
    text?: string | undefined;
    value?: string | undefined;
}

export interface SelectListGroup {
    disabled: boolean;
    name?: string | undefined;
}

export interface PricePlanSimple {
    id: number;
    name?: string | undefined;
    price?: string | undefined;
}

export interface ExternalApiKeySimple {
    id: number;
    name?: string | undefined;
    description?: string | undefined;
    key?: string | undefined;
    type: KeyTypes;
    typeString?: string | undefined;
    expirationDate?: Date | undefined;
}

export enum KeyTypes {
    Src = 0,
    SolarFarmer = 1,
}

export interface AddExternalApiKeyRequest {
    name?: string | undefined;
    description?: string | undefined;
    key?: string | undefined;
    type: KeyTypes;
    expirationDate?: Date | undefined;
}

/** A definition of updating entity property. */
export interface UpdatePropertyRequest {
    /** Property name */
    propertyName?: string | undefined;
    /** A new value to update.  */
    propertyValue?: any | undefined;
}

export interface DatasetSimple {
    id: number;
    name?: string | undefined;
    isDefault: boolean;
    isLocked: boolean;
    isArchive: boolean;
    createdBy?: string | undefined;
    createdAt: Date;
    modifiedBy?: string | undefined;
    modifiedAt?: Date | undefined;
}

export interface FinancesSimple extends DatasetSimple {
    capacityAugmentationFileId?: number | undefined;
    capacityAugmentationFileName?: string | undefined;
    taxDepreciationType: TaxDepreciationTypes;
    dcSide: number;
    powerConversionSystem: number;
    gridManagementSystem: number;
    lvXmerAndSwitchgear: number;
    preventativeMaintenanceAndDispatchCost: number;
    capacityLongTermServiceAgreement: number;
    esomCostEscalationRate: number;
    pvModuleEquipment: number;
    pcsInvertersAndAssociatedControls: number;
    pvEquipmentEnggAndConstruction: number;
    pvlvTransformer: number;
    pvFixedOMCost: number;
    pvomCostEscalationRate: number;
    wtgFoundations: number;
    wtgSupplyAndOptions: number;
    wtgInstallation: number;
    collectionSystem: number;
    controlSystem: number;
    windLVXmers: number;
    windFixedOMCost: number;
    windOMCostEscalationRates: number;
    landLeaseAndAcquisition: number;
    siteAndPublicRoads: number;
    buildings: number;
    directInterconnectionCost: number;
    systemUpgrades: number;
    projectDevelopment: number;
    projectManagement: number;
    contingencyAndOverhead: number;
    constructionManagementAndEngg: number;
    federalITCRateOfInstalledCost: number;
    taxRate: number;
    salesTaxRate: number;
    debtForBESSFinancing: number;
    debtFinancingRate: number;
    debtFinancingTerm: number;
    discountRate: number;
    equipmentInsuranceFee: number;
    ownerOrganizationName?: string | undefined;
    linkedScenarios?: ScenarioSimple[] | undefined;
}

export enum TaxDepreciationTypes {
    NotSet = 0,
    Macrs7Years = 1,
    Macrs5Years = 2,
    NoMacrs = 3,
    UserDefiniedMacrs = 4,
}

export interface ScenarioSimpleBase {
    id: number;
    projectId: number;
    projectName?: string | undefined;
    name?: string | undefined;
    createdAt: Date;
    modifiedAt: Date;
    yearsToRun: RunOptions;
    yearsToRunString?: string | undefined;
    systemConfiguration: SystemConfigurations;
    systemConfigurationString?: string | undefined;
    startYear: number;
    endYear?: number | undefined;
    tag: ScenarioTags;
    selectedRunYears?: number[] | undefined;
}

export interface ScenarioSimple extends ScenarioSimpleBase {
    interconnectionCapacity?: number | undefined;
    acLineEfficiency?: number | undefined;
    acMainTransformerEfficiency?: number | undefined;
    hasAnyInputFile: boolean;
    state: CalculationStates;
    stateString?: string | undefined;
    errors?: string[] | undefined;
    result?: ShortResult | undefined;
    calculationStartDate?: Date | undefined;
    calculationEndDate?: Date | undefined;
    calculationProgress?: number | undefined;
    createdBy?: string | undefined;
    sourceScenarioId: number;
    wholesaleMarketPriceId?: number | undefined;
    finansesDatasetId?: number | undefined;
    incomeAdjustmentsId?: number | undefined;
    lossFactorsId?: number | undefined;
    pvProductionProfileId?: number | undefined;
    windProductionProfileId?: number | undefined;
    otherBessInputId?: number | undefined;
}

export enum CalculationStates {
    NotSet = 0,
    InProgress = 1,
    Finished = 2,
    Error = 3,
    Preprocessing = 4,
    Canceled = 5,
}

export interface ShortResult {
    esAverageCycles?: number | undefined;
    esAverageSoc?: number | undefined;
    irr?: number | undefined;
}

export enum RunOptions {
    None = 0,
    FirstYearOnly = 1,
    FirstAndLastYears = 2,
    AllYears = 3,
    CustomerSelectedYears = 4,
}

export enum SystemConfigurations {
    None = 0,
    Standalone = 1,
    SolarPV = 2,
    SolarPVOnSharedBus = 3,
    WindOnShareBus = 4,
    SolarPVAndAcCoupledWithWind = 5,
    SolarPVAndWind = 6,
}

export enum ScenarioTags {
    Draft = 0,
    Analysis = 1,
    Final = 2,
}

export interface AddDatasetRequest {
    name: string;
}

/** Payload for cloning dataset. */
export interface CloneDatasetRequest {
    /** New dataset name */
    name?: string | undefined;
}

export interface IncomeAdjustmentFactorsSimple extends DatasetSimple {
    fileId?: number | undefined;
    fileName?: string | undefined;
    ownerOrganizationName?: string | undefined;
}

export interface LossFactorsSimple extends DatasetSimple {
    acLineEfficiency?: number | undefined;
    acMainTransformerEfficiency?: number | undefined;
    storageChargeDischargeEfficiency?: number | undefined;
    dcLineEfficiency?: number | undefined;
    dcdcConverterEfficiency?: number | undefined;
    dcacInverterEfficiency?: number | undefined;
    auxiliaryPowerLoss?: number | undefined;
    minimumStateOfCharge?: number | undefined;
    maximumStateOfCharge?: number | undefined;
    initialStateOfCharge?: number | undefined;
    windTotalEfficiency?: number | undefined;
    windAnnualDerating?: number | undefined;
    pvDCACInverterEfficiency?: number | undefined;
    pvAnnualDerating?: number | undefined;
}

export interface UpdateLossFactorsDatasetRequest {
    acLineEfficiency: number;
    acMainTransformerEfficiency: number;
    storageChargeDischargeEfficiency: number;
    dcLineEfficiency: number;
    dcdcConverterEfficiency: number;
    dcacInverterEfficiency: number;
    auxiliaryPowerLoss: number;
    minimumStateOfCharge: number;
    maximumStateOfCharge: number;
    initialStateOfCharge: number;
    windTotalEfficiency?: number | undefined;
    windAnnualDerating?: number | undefined;
    pvDCACInverterEfficiency?: number | undefined;
    pvAnnualDerating?: number | undefined;
}

export interface AddOrganizationRequest {
    name: string;
    description?: string | undefined;
    pricePlanId: number;
    expirationDate: Date;
}

export interface UpdateOrganizationRequest {
    name: string;
    description?: string | undefined;
    pricePlanId: number;
    expirationDate: Date;
}

export interface OtherBessInputsSimple extends DatasetSimple {
    ownerOrganizationName?: string | undefined;
    annualCycleCapFileId?: number | undefined;
    annualCycleCapFileName?: string | undefined;
    augmentationCapacityFileId?: number | undefined;
    augmentationCapacityFileName?: string | undefined;
    capacityRetentionFileId?: number | undefined;
    capacityRetentionFileName?: string | undefined;
    percentageChargingFromRenewableFileId?: number | undefined;
    percentageChargingFromRenewableFileName?: string | undefined;
    shadowPriceFileId?: number | undefined;
    shadowPriceFileName?: string | undefined;
    isShadowPriceChecked: boolean;
}

export interface PortfolioSimple {
    id: number;
    name?: string | undefined;
    description?: string | undefined;
    createdBy?: string | undefined;
    createdAt: Date;
    company?: string | undefined;
    projects?: ProjectSimple[] | undefined;
}

export interface ProjectSimple {
    id: number;
    isoBa: IsoBa;
    isoBaName?: string | undefined;
    name?: string | undefined;
    startDate: Date;
    endDate?: Date | undefined;
    scenarios?: ScenarioSimple[] | undefined;
    createdBy?: string | undefined;
    createdAt: Date;
    company?: string | undefined;
    portfolioIds?: number[] | undefined;
}

export enum IsoBa {
    None = 0,
    US_NYISO = 1,
    US_CAISO = 2,
    US_PJM = 3,
    US_MISO = 4,
    US_SPP = 5,
    US_ERCOT = 6,
    US_ISONE = 7,
    CAN_IESO = 8,
    CAN_AESO = 9,
    ES_PENINSULA = 10,
}

export interface Exception {
    Message: string;
    InnerException?: Exception | undefined;
    Source?: string | undefined;
    StackTrace?: string | undefined;
}

export interface HeroException extends Exception {
}

export interface AddPortfolioRequest {
    portfolioName: string;
    portfolioDescription?: string | undefined;
}

export interface UpdateLinkedProjectsRequest {
    projectsIds?: number[] | undefined;
}

export interface ProductionProfileSimple extends DatasetSimple {
    sourceType: SourceTypes;
    annualDerating?: number | undefined;
    pvProductionSoftwareType?: PvProductionSoftwareType | undefined;
    productionProfileType: ProductionProfileTypes;
    productionProfileFileId?: number | undefined;
    productionProfileFileName?: string | undefined;
    windAnnualDeratingFileId?: number | undefined;
    windAnnualDeratingFileName?: string | undefined;
    windPTCPriceFileId?: number | undefined;
    windPTCPriceFileName?: string | undefined;
}

export enum SourceTypes {
    Solar = 0,
    Wind = 1,
}

export enum PvProductionSoftwareType {
    Hero = 0,
    Pvsyst = 1,
    SolarFarmer = 2,
    PlantPredict = 3,
    Src = 4,
}

export enum ProductionProfileTypes {
    AnnualProduction = 0,
    Lifetime = 1,
}

export interface AddProjectRequest {
    projectName?: string | undefined;
    isoBa: IsoBa;
    portfolioIds?: number[] | undefined;
}

/** Model for GetProjectsWithScenariosTree endpoint */
export interface ProjectWithScenarioSimple {
    /** Project Id */
    projectId: number;
    /** Name of project */
    projectName?: string | undefined;
    /** Scenarios in selected project */
    scenarios?: KeyNameSimple[] | undefined;
}

/** Simple key value */
export interface KeyNameSimple {
    /** Element Id */
    id: number;
    /** Name of selected element */
    name?: string | undefined;
}

export interface ReleaseNoteModel {
    major: number;
    minor: number;
    bugFix: number;
    content?: string | undefined;
}

export interface SummaryResult {
    startYear: number;
    endYear?: number | undefined;
    systemConfiguration: SystemConfigurations;
    systemConfigurationName?: string | undefined;
    interconnectionCapacity?: number | undefined;
    solarPvCapacityDc?: number | undefined;
    inverterCapacityAc?: number | undefined;
    inverterLoadingRatio?: number | undefined;
    bessEnergyCapacityDc?: number | undefined;
    bessEnergyCapacityPoi?: number | undefined;
    bessDuration?: number | undefined;
    minimumSocLimit?: number | undefined;
    maximumSocLimit?: number | undefined;
    dcAcInverterEfficiency?: number | undefined;
    acLossesBetweenPccAndPoi?: number | undefined;
    bessOperatingIncomeResults?: BessOperatingIncomeResult[] | undefined;
}

export interface BessOperatingIncomeResult {
    year: number;
    pvEsIncome?: number | undefined;
    pvEsIncomeWithoutEs?: number | undefined;
    incomeEs?: number | undefined;
    usableEnergyAtPoi?: number | undefined;
    equivalentFullCycles?: number | undefined;
    totalEsIncomeUsd?: number | undefined;
    totalEsIncomeKw?: number | undefined;
    pvRevenueLoss?: number | undefined;
    damEnergy?: number | undefined;
    rtmEnergy?: number | undefined;
    damRegUp?: number | undefined;
    damRegDown?: number | undefined;
    damSr?: number | undefined;
}

export interface ScenarioTimeseriesChartItemSimple {
    timestamp: Date;
    dayAheadEnergyPrice: number;
    realTimeEnergyPrice: number;
    regulationDownCapacityPrice: number;
    regulationUpCapacityPrice: number;
    spinningReservePrice: number;
    pvCurtailment: number;
    esCharging: number;
    esDischarging: number;
    windCurtailment: number;
    regulationDownCapacityWhileCharging: number;
    regulationDownCapacityWhileDischarging: number;
    regulationUpCapacityWhileCharging: number;
    regulationUpCapacityWhileDischarging: number;
    spinngingReserveWhileCharging: number;
    spinngingReserveWhileDischarging: number;
    rte: number;
    dae: number;
    pvExportToGrid: number;
    windExportToGrid: number;
    maxOutput: number;
    netRegEnergy: number;
    esSoeEndOfInterval: number;
    maxSoe: number;
    esOutputPoi: number;
}

export interface DispatchResultsSummaryResult {
    date: Date;
    pvResult?: PVResult | undefined;
    bessResults?: BESSResultResult | undefined;
    damEnergy?: EnergyMarketResult | undefined;
    rtmEnergy?: EnergyMarketResult | undefined;
    regulationUp?: RegulationMarketResult | undefined;
    regulationDown?: RegulationMarketResult | undefined;
    spinningReserve?: SpinningReserveResult | undefined;
}

export interface PVResult {
    totalDcPvProduction?: number | undefined;
    esDcChargeFromPvClipped?: number | undefined;
    esChargeFromPvNonClipped?: number | undefined;
    inverterClippingDc?: number | undefined;
    economicCurtailmentDc?: number | undefined;
    gridExportDc?: number | undefined;
    gridExportPoi: number;
    pvRevenueOfGridExport?: number | undefined;
    pvRevenueLossDueToEsOperation?: number | undefined;
    totalPvIncomeWithoutEs?: number | undefined;
}

export interface BESSResultResult {
    cycle?: number | undefined;
    averageSoc?: number | undefined;
    totalChargeDc?: number | undefined;
    totalDischargeDc?: number | undefined;
    roundTripEfficiencyDc?: number | undefined;
    revenueOfDaEnergy?: number | undefined;
    revenueOfRtEnergy?: number | undefined;
    revenueOfRegUp?: number | undefined;
    revenueOfRegDown?: number | undefined;
    revenueOfSr?: number | undefined;
    pvRevenueLossDueToEsOperation?: number | undefined;
    totalBessIncome?: number | undefined;
}

export interface EnergyMarketResult {
    averageLmpPrice?: number | undefined;
    averageSalePrice?: number | undefined;
    averagePurchasePrice?: number | undefined;
    totalEnergySale?: number | undefined;
    totalEnergyPurchase?: number | undefined;
    revenueOfEnergySale?: number | undefined;
    costOfEnergyPurchase?: number | undefined;
    priceDaeSum?: number | undefined;
}

export interface RegulationMarketResult {
    averagePrice?: number | undefined;
    averageSalePrice?: number | undefined;
    totalCapacityCommitment?: number | undefined;
    totalEnergyDeployment?: number | undefined;
    revenueOfRegCapacity?: number | undefined;
    revenueOfRegEnergy?: number | undefined;
    revenueOfRegMovement?: number | undefined;
}

export interface SpinningReserveResult {
    averagePrice?: number | undefined;
    averageSalePrice?: number | undefined;
    totalCapacityCommitment?: number | undefined;
    revenueOfSrCapacity?: number | undefined;
}

export interface ConstraintDefinitionSimple {
    scenarioId: number;
    marketProductType: DatasetFileTypes;
    years?: number[] | undefined;
    isCharging: boolean;
    isBusinessDay: boolean;
    constraints?: number[][] | undefined;
}

export enum DatasetFileTypes {
    NotSet = 0,
    DayAheadEnergyPrices = 1,
    RealTimeEnergyPrice = 2,
    RegUpPrices = 3,
    RegDownPrices = 4,
    SpinningReservePrices = 5,
    RegulationMileagePrice = 6,
    CapacityMarketPrice = 7,
    CapacityAugmentation = 8,
    IncomeAdjustmentFactors = 9,
    ProductionProfile = 10,
    WindAnnualDerating = 11,
    WindPTCPrice = 12,
    PercentageChargingFromRenewable = 13,
    AugmentationCapacity = 14,
    AnnualCycleCap = 15,
    ShadowPrice = 16,
    CapacityRetention = 17,
    AFRREnergyDown = 18,
    AFRREnergyUp = 19,
    AFRRPower = 20,
    MFRREnergyDown = 21,
    MFRREnergyUp = 22,
}

export interface SetConstraintDefinitionRequest {
    marketProductType: DatasetFileTypes;
    years?: number[] | undefined;
    isBusinessDay: boolean;
    isCharging: boolean;
    constraints?: number[][] | undefined;
}

export interface ScenarioDetailed extends ScenarioSimple {
    isoBa: IsoBa;
    isoBaName?: string | undefined;
    storage?: StorageSimple | undefined;
    photovoltaic?: PhotovoltaicSimple | undefined;
    wind?: WindSimple | undefined;
    energyCapacityAtPoi?: number | undefined;
    acMediumVoltageTransformerEfficiency: number;
    installedPowerCapacity: number;
    defaultAcLineEfficiency?: number | undefined;
    defaultAcMainTransformerEfficiency?: number | undefined;
    defaultStorageChargeDischargeEfficiency?: number | undefined;
    defaultDCLineEfficiency?: number | undefined;
    defaultDCDCConverterEfficiency?: number | undefined;
    defaultAuxiliaryPowerLoss?: number | undefined;
    defaultDCACInverterEfficiency?: number | undefined;
    defaultInitialStateOfCharge?: number | undefined;
    defaultMaximumStateOfCharge?: number | undefined;
    defaultPvDcAcInverterEfficiency?: number | undefined;
    defaultPvAnnualDerating?: number | undefined;
    defaultWindACCapacity?: number | undefined;
}

export interface StorageSimple {
    inverterPowerCapacity?: number | undefined;
    installedEnergyCapacity?: number | undefined;
    contractedEnergyCapacity?: number | undefined;
    storageMaxDischargePower?: number | undefined;
    storageMaxChargePower?: number | undefined;
    storageChargeDischargeEfficiency?: number | undefined;
    dcLineEfficiency?: number | undefined;
    dcdcConverterEfficiency?: number | undefined;
    auxiliaryPowerLoss?: number | undefined;
    dcacInverterEfficiency?: number | undefined;
    minimumStateOfCharge?: number | undefined;
    maximumStateOfCharge?: number | undefined;
    initialStateOfCharge?: number | undefined;
    maxDischargePowerForRegulationUp?: number | undefined;
    maxChargePowerForRegulationDown?: number | undefined;
    maxDischargePowerForSpin?: number | undefined;
    percentageChargingFromRenewableFileId?: number | undefined;
    percentageChargingFromRenewableFileName?: string | undefined;
    shadowPriceFileId?: number | undefined;
    shadowPriceFileName?: string | undefined;
    stateOfHealthFileId?: number | undefined;
    stateOfHealthFileName?: string | undefined;
    augmentationCapacityFileId?: number | undefined;
    augmentationCapacityFileName?: string | undefined;
    annualCycleCapFileId?: number | undefined;
    annualCycleCapFileName?: string | undefined;
}

export interface PhotovoltaicSimple {
    dcCapacity?: number | undefined;
    acCapacity?: number | undefined;
    annualDerating?: number | undefined;
    dcacInverterEfficiency?: number | undefined;
    pvesComInsCap?: number | undefined;
    pvdcLineEffOW?: number | undefined;
    pvdcConvEffOW?: number | undefined;
    pvacInvEffOW?: number | undefined;
    pvProductionProfileFileId?: number | undefined;
    pvProductionProfileFileName?: string | undefined;
    isLifetimeProductionProfile: boolean;
    pvLifetimeProductionProfileId?: string | undefined;
    pvLifetimeProductionProfileName?: string | undefined;
}

export interface WindSimple {
    acCapacity?: number | undefined;
    totalEfficiency?: number | undefined;
    windProductionProfileFileId?: number | undefined;
    windProductionProfileFileName?: string | undefined;
    windClippingProfileFileId?: number | undefined;
    windClippingProfileFileName?: string | undefined;
    isLifetimeProductionProfile: boolean;
    windLifetimeProductionProfileFileId?: number | undefined;
    windLifetimeProductionProfileFileName?: string | undefined;
    annualDeratingFileId?: number | undefined;
    annualDeratingFileName?: string | undefined;
}

export interface AddScenarioRequest {
    projectId: number;
    name?: string | undefined;
}

export interface GetCalculationProgressResponse {
    isCalculating: boolean;
    message?: string | undefined;
    progress: number;
    preprocessingProgress: number;
}

/** Request for cloning existing scenario. */
export interface CloneScenarioRequest {
    /** Name for new Scenario (existing scenario will to be cloned) */
    name?: string | undefined;
}

export interface ScenarioCompareSimple extends ScenarioSimpleBase {
    /** IRR */
    irr?: number | undefined;
    /** Term (in Years) */
    term?: number | undefined;
    /** Present value of Total Expenses ($) */
    totalExpenses?: number | undefined;
    /** Present value of Total Earnings ($) */
    totalEarnings?: number | undefined;
    /** Present value of Total Profit ($) */
    totalProfit?: number | undefined;
    /** ES Average cycles */
    esAverageCycles?: number | undefined;
    /** ES average SOC (%) */
    esAverageSOC?: number | undefined;
    /** Interconnection Limit (MW) */
    interconnectionLimit?: number | undefined;
    /** Wholesale Market Price Input Dataset Name	 */
    whosaleMarketDatasetName?: string | undefined;
    /** Finances Input Dataset Name */
    financesDatasetName?: string | undefined;
    /** Income Adjustment Dataset Name */
    incomeAdjustmentDatasetName?: string | undefined;
    /** Loss Factors Dataset Name */
    lossFactorsDatasetName?: string | undefined;
    /** Production Profiles Dataset Name */
    productionProfileDatasetName?: string | undefined;
    /** Cycling Control Dataset Name */
    otherBessInputDatasetName?: string | undefined;
    /** Power Capacity (MW) */
    esPowerCapacity?: number | undefined;
    /** Energy Capacity (MWh) */
    esEnergyCapacity?: number | undefined;
    /** Maximum Discharge Power (MW) */
    maximumDischargePower?: number | undefined;
    /** DC Capacity (MW) */
    pvDcCapacity?: number | undefined;
    /** AC Capacity (MW) */
    pvAcCapacity?: number | undefined;
    /** DC-AC Inverter Efficienty (%) */
    pvDcAcInverterEfficienty?: number | undefined;
    /** Annual Derating (%) */
    pvAnnualDerating?: number | undefined;
    /** AC Capacity (MW) */
    windAcCapacity?: number | undefined;
    /** Total Efficienty (%) */
    windTotalEfficiency?: number | undefined;
    /** Real-Time Energy Participation Limit */
    realTimeEnergyParticipationLimit: boolean;
    /** Regulation Participation Limit */
    regulationParticipationLimit: boolean;
    /** Spinning Reserve Participation Limit */
    spinningReserveParticipationLimit: boolean;
}

export interface ScenarioCompareDetails {
    details?: ScenarioCompareDetailsData[] | undefined;
    yearlyData?: ScenarioCompareDetailsYearlyData[] | undefined;
}

export interface ScenarioCompareDetailsData {
    projectCost?: ProjectCostRecord | undefined;
    esCost?: EsCostRecord | undefined;
    developmentCost?: DevCostRecord | undefined;
    pvCost?: PvCostRecord | undefined;
    projectCostTotal: number;
    esCostTotal: number;
    developmentCostTotal: number;
    pvCostTotal: number;
}

export interface ProjectCostRecord {
    "Total PV Cost": number;
    "Total Wind Cost": number;
    "Total ES Cost": number;
    "Total Development Cost": number;
    "Total Equip Sales Tax": number;
}

export interface EsCostRecord {
    "DC Side": number;
    "Power Conversion System": number;
    "Grid Management System": number;
    "LV Xmer and Switchgear": number;
}

export interface DevCostRecord {
    "Site Infrastructure": number;
    "Interconnection and Network Upgrade": number;
    "Owner Cost": number;
}

export interface PvCostRecord {
    "Module Equipment": number;
    "Inverter and Control": number;
    "Engg and Construction": number;
    "LV Xmer and Switchgear": number;
}

export interface ScenarioCompareDetailsYearlyData {
    year: number;
    cashflow?: CashFlowTableRecord[] | undefined;
    esOperatingRevenue?: RevenueAnnualRecord[] | undefined;
    esOperatingCost?: CostAnnualRecord[] | undefined;
    resourceIncome?: IncomeAnnualRecord[] | undefined;
}

export interface CashFlowTableBase {
    Year: number;
    "ES Operating": number;
    "Capacity Market": number;
    "Operating Expenditure": number;
    "Equity Payment": number;
    "Federal ITC Rebate": number;
    "Tax Depreciation": number;
    "ES Pre-Tax Cashflow": number;
    "ES Cumulative Cashflow": number;
    "ES Average Cycles"?: number | undefined;
    "ES Average SOC"?: number | undefined;
}

export interface CashFlowTableRecord extends CashFlowTableBase {
    "PV Operating": number;
    "Wind Operating": number;
}

export interface RevenueAnnualRecord {
    Year?: number | undefined;
    DAE: number;
    RTE: number;
    "Regulation Up": number;
    "Regulation Down": number;
    "Spinning Reserve": number;
    Total: number;
}

export interface CostAnnualRecord {
    Year: number;
    DAE: number;
    RTE: number;
    PV: number;
    Wind: number;
    Total: number;
}

export interface IncomeAnnualRecord {
    "ES Operating Income": number;
    "PV Operating Income": number;
    "Wind Operating Income": number;
    Year: number;
}

export interface PredictionLogResponseItem {
    projectId: number;
    scenarioId: number;
    calculationId: number;
    calculationState: CalculationStates;
    projectName?: string | undefined;
    scenarioName?: string | undefined;
    runDate: Date;
    finishedDate?: Date | undefined;
}

export interface PredictionLogRequest {
    pageNumber: number;
    pageCount: number;
    filterText?: string | undefined;
}

export interface SendTestEmailRequest {
    smtpConfiguration?: SmtpSettings | undefined;
    receipient?: string | undefined;
    message?: string | undefined;
}

export interface SmtpSettings {
    smtpServer?: string | undefined;
    port: number;
    from?: string | undefined;
    login?: string | undefined;
    password?: string | undefined;
}

export interface UserSimple {
    id: string;
    userName?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    veracityAlias?: string | undefined;
    employerId?: number | undefined;
    isEnabled: boolean;
    isApiKeyActive: boolean;
    organization?: OrganizationSimple | undefined;
    roleId: number;
    roleName?: string | undefined;
}

export interface WholesaleMarketSimple extends DatasetSimple {
    isoBaItems?: IsoBa[] | undefined;
}

export interface WholesaleMarketDatasetWithFilesSimple extends DatasetSimple {
    dayAheadEnergyPricesFile?: WholesaleMarketDatasetFileInfo | undefined;
    realTimeEnergyPriceFile?: WholesaleMarketDatasetFileInfo | undefined;
    regUpPricesFile?: WholesaleMarketDatasetFileInfo | undefined;
    regDownPricesFile?: WholesaleMarketDatasetFileInfo | undefined;
    spinningReservePricesFile?: WholesaleMarketDatasetFileInfo | undefined;
    regulationMileagePriceFile?: WholesaleMarketDatasetFileInfo | undefined;
    capacityMarketPriceFile?: WholesaleMarketDatasetFileInfo | undefined;
    afrrEnergyDownFile?: WholesaleMarketDatasetFileInfo | undefined;
    afrrEnergyUpFile?: WholesaleMarketDatasetFileInfo | undefined;
    afrrPowerFile?: WholesaleMarketDatasetFileInfo | undefined;
    mfrrEnergyDownFile?: WholesaleMarketDatasetFileInfo | undefined;
    mfrrEnergyUpFile?: WholesaleMarketDatasetFileInfo | undefined;
    createdById: string;
    ownerName?: string | undefined;
    ownerOrganizationName?: string | undefined;
    linkedScenarios?: ScenarioSimple[] | undefined;
    isoBaItems?: IsoBa[] | undefined;
    datasetProvider: WholesaleMarketProviders;
    customPriceProviderName?: string | undefined;
}

export interface WholesaleMarketDatasetFileInfo {
    id?: number | undefined;
    name?: string | undefined;
}

export enum WholesaleMarketProviders {
    DNV = 0,
    Other = 2147483647,
}

export interface AddWholesaleMarketDatasetRequest extends AddDatasetRequest {
    isoBaItems: IsoBa[];
    datasetProvider?: WholesaleMarketProviders | undefined;
    customPriceProviderName?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}